import React from "react"
import { useTheme } from "@mui/material/styles"
import styled, { keyframes } from "styled-components"
import { isValidColor } from "../../utils/color"

const NodeWrap = styled.g`
  > circle {
    vector-effect: non-scaling-stroke;
  }
`

const pathTrailAnim = keyframes`
0% {
  stroke-dashoffset: 0;
}
100% {
  stroke-dashoffset: -12;
}
`

const HighlightCircle = styled.circle`
  // animation: ${pathTrailAnim} 1s linear infinite;
  stroke-dasharray: 1, 5;
`

const BgCircle = styled.circle`
  transition: opacity 0.6s ease;
`

export default function CustomNode({
  parentId,
  isActive = false,
  isOnlyItemActive = false,
  node,
  id,
  index,
  x,
  y,
  nodeTextFormatter = null,
  paletteKey = "secondary",
  activeNodeBorderScale = 1
}) {
  const maskId = `${parentId}__mask-active-node--${index}`
  const radialGradientId = `${parentId}__mask-radial-grad--${index}`
  const theme = useTheme()
  const scale = isActive ? 1.2 : 1
  const nodeColor =
    node.data && node.data.color && isValidColor(node.data.color)
      ? node.data.color
      : theme.palette[paletteKey].main
  return (
    <NodeWrap id={`${parentId}__${index}`}>
      <g>
        <BgCircle
          fill={theme.palette.text.primary}
          r={40 * activeNodeBorderScale}
          cx={node.x}
          cy={node.y}
          mask={`url(#${maskId})`}
          opacity={+isOnlyItemActive}
        />
      </g>
      <g>
        <circle
          fill={theme.basePalette.bg}
          r={10 * scale}
          cx={node.x}
          cy={node.y}
        />
        <circle
          fill={nodeColor}
          fillOpacity={isActive ? 0.5 : 0.2}
          stroke={nodeColor}
          strokeWidth={2}
          r={10 * scale}
          cx={node.x}
          cy={node.y}
        />
      </g>
      <text
        x={node.x}
        y={node.y}
        fill={theme.palette.text.primary}
        textAnchor="middle"
        fontSize="0.8rem"
      >
        <tspan dy={-20}>
          {typeof nodeFormatter === "function" ? nodeTextFormatter(node) : id}
        </tspan>
      </text>
      <defs>
        <mask id={maskId}>
          <HighlightCircle
            fill={"none"}
            stroke={theme.palette.text.primary}
            r={40 * activeNodeBorderScale}
            cx={node.x}
            cy={node.y}
          />
        </mask>
        <radialGradient id={radialGradientId}>
          <stop offset={0.7} stopOpacity={0} stopColor={"white"} />
          <stop offset={1} stopOpacity={0.15} stopColor={"white"} />
        </radialGradient>
      </defs>
    </NodeWrap>
  )
}
